/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_share__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _modules_nav__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _modules_slider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);





$(function () {
  Object(_modules_share__WEBPACK_IMPORTED_MODULE_0__["default"])();
  Object(_modules_nav__WEBPACK_IMPORTED_MODULE_1__["default"])();
  Object(_modules_slider__WEBPACK_IMPORTED_MODULE_2__["default"])();
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);


var share = function share() {
  var shareSelector = '.share',
      socialListSelector = '.social-list',
      logoSelector = '.header .logo',
      logo = $(logoSelector);

  function initSocialLikes() {
    var socialList = $("".concat(shareSelector, " ").concat(socialListSelector));
    socialList.socialLikes({
      counters: false
    });
  }

  ;

  function bindShare() {
    var document = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].document,
        activeClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].activeClass,
        showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass,
        hideClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].hideClass,
        btnShareSelector = '.js-btn-share';
    document.on('click', btnShareSelector, function () {
      var _this = $(this),
          _parent = _this.parent(),
          _socialList = _parent.find(socialListSelector),
          isMaxMedia = window.matchMedia('(max-width: 479px)').matches;

      if (isMaxMedia) {
        logo.toggleClass(hideClass);
      }

      _this.toggleClass(activeClass);

      _socialList.toggleClass(showClass);
    });

    function hideByTime(time) {
      document.on('mouseleave', shareSelector, function () {
        var _this = $(this),
            _btnShare = _this.find(btnShareSelector),
            _socialList = _this.find(socialListSelector),
            isShowClass = _socialList.hasClass(showClass);

        if (isShowClass) {
          this.resetState = setTimeout(function () {
            logo.removeClass(hideClass);

            _btnShare.removeClass(activeClass);

            _socialList.removeClass(showClass);
          }, time);
        }
      });
      document.on('mouseenter', shareSelector, function () {
        var _this = $(this),
            isShowClass = _this.find(socialListSelector).hasClass(showClass);

        if (isShowClass) {
          clearTimeout(this.resetState);
        }
      });
    }

    ;
    hideByTime(4000);
  }

  ;
  bindShare();
  initSocialLikes();
};

/* harmony default export */ __webpack_exports__["default"] = (share);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "classes", function() { return classes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectors", function() { return selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jQueryObjects", function() { return jQueryObjects; });
var classes = {
  activeClass: 'active',
  inActiveClass: 'inactive',
  showClass: 'show',
  hideClass: 'hide',
  disableClass: 'disable',
  currentClass: 'current',
  errorClass: 'error',
  bodyClass: 'body'
};
var selectors = {
  btnCloseSelector: '.js-btn-close'
};
var jQueryObjects = {
  _window: $(window),
  document: $(document)
};


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);


var nav = function nav() {
  var navItemSelector = '.js-nav-item',
      routeSelector = '.route',
      dataRoute = 'data-route';

  function onClickNavItem() {
    $(document).on('click', navItemSelector, function (e) {
      e.preventDefault();

      var _this = $(this),
          id = _this.attr(dataRoute),
          _route = $("".concat(routeSelector, "[").concat(dataRoute, "='").concat(id, "']"));

      scrollTo(_route);
    });
  }

  ;

  function scrollTo(elemSelector) {
    var elem = $(elemSelector);
    $('html, body').animate({
      scrollTop: elem.offset().top
    }, 'slow');
  }

  ;
  Object(_modules__WEBPACK_IMPORTED_MODULE_0__["setAttr"])(navItemSelector, dataRoute);
  Object(_modules__WEBPACK_IMPORTED_MODULE_0__["setAttr"])(routeSelector, dataRoute);
  onClickNavItem();
};

/* harmony default export */ __webpack_exports__["default"] = (nav);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAttr", function() { return setAttr; });
function setAttr(elemSelector, attr) {
  var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var elem = $(elemSelector);
  elem.each(function (i, it) {
    $(it).attr(attr, i + count);
  });
}

;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var slider = function slider() {
  var sliderSelector = '.slider',
      slider = $(sliderSelector),
      sliderItemSelector = '.slider__item';
  slider.each(function () {
    var _this = $(this);

    _this.magnificPopup({
      delegate: sliderItemSelector,
      type: 'image',
      removalDelay: 300,
      mainClass: 'mfp-no-margins',
      tLoading: 'Загрузка...',
      gallery: {
        enabled: true,
        preload: [1, 2],
        navigateByImgClick: false,
        arrowMarkup: "<button class=\"mfp-arrow mfp-arrow-%dir%\">\n          </button>"
      },
      image: {
        markup: "<div class=\"mfp-figure\">\n          <div class=\"mfp-close\"></div>\n          <figure>\n            <div class=\"mfp-img\"></div>\n            <div class=\"mfp-bottom-bar\">\n              <div class=\"mfp-title\"></div>\n            </div>\n          </figure>\n        </div>",
        cursor: null
      },
      zoom: {
        enabled: false
      }
    });
  });
};

/* harmony default export */ __webpack_exports__["default"] = (slider);

/***/ })
/******/ ]);